import React, { useEffect } from "react";
import icEthizoPopups from "../../assets/images/ic-ethizo-popups.svg";
import icClosePopup from "../../assets/images/ic-close-popup.svg";

function MainPageDialog({
    title,
    component,
    children,
    isShowCloseBtn = true,
    footer = true,
    maxHeight = false,
    contentCls = 'p-2 px-6',
    footerList = [],
    onCancelHandler,
    modalSize = 'large', // Large and small popup screen size
    hideOverFlow,
    contentScroll=true,
    customHeight
    }) {

    //for removing whole page scroll on opening modal component
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
        document.body.style.overflow = 'auto';
        // componentwillunmount in functional component.
        // Anything in here is fired on component unmount.
        }
    }, [])

    return (
        <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[999] outline-none focus:outline-none">
                <div className={`relative ${modalSize == 'small' ? 'w-[400px]' : (modalSize == "md" ? "w-[850px]" : (modalSize == "lg" ? "w-[1200px]" : '2xl:container1440 xl:container1440 lg:container1024 md:container1024 sm:container1024'))}   m-auto`}>
                {/*content*/}
                <div className={`border-0 rounded shadow ${maxHeight ? 'sm-max-popup-height' : "custom-popup-height"} ${customHeight ? customHeight : ""} relative flex flex-col w-full bg-white outline-none`}>
                    {/*header*/}
                    {title && <div className="flex rounded-tl z-10 rounded-tr items-center justify-between p-2 popup-header-shadow bg-gray-f8">
                        <h3 className="text-lg text-black-300 font-medium flex gap-2 items-center">
                            <span className="bg-white w-8 h-8 border border-gray-e5 flex items-center justify-center rounded-full min-w-[32px] min-h-[32px]">
                                <img src={icEthizoPopups} className="cursor-pointer w-[17px]" alt="" />
                            </span>
                            {title}
                        </h3>
                        {isShowCloseBtn ? 
                            <div className="pr-2">
                                <a className="cursor-pointer border border-gray-89 hover:bg-gray-ec rounded-lg p-2 flex h-8 w-8" onClick={onCancelHandler}>
                                    <img src={icClosePopup} className="w-[14px]" />
                                </a>
                            </div>
                            : null
                        }

                    </div>}

                    {/*body*/}
                    {children ? (
                        <>
                            <PageDialogContent contentScroll={contentScroll} hideOverFlow={hideOverFlow} contentCls={contentCls}>
                            {children}
                            </PageDialogContent>
                            {/*footer*/}
                            {footer && <PageDialogFooter footerList={footerList} />}
                        </>
                    ) : (
                    <>
                        {component ? component : ''}
                    </>
                    )}
                </div>
                </div>
            </div>
            <div className="opacity-60 fixed inset-0 z-[998] bg-black"></div>
        </>
    );
}

export const PageDialogContent = ({ children, contentScroll, contentCls = 'p-2 px-6', hideOverFlow }) => {
    return (
        <>
         <div className={`relative px-6 text-sm flex-1  w-[360px] bg-white md:w-auto overflow-auto ${contentScroll && !hideOverFlow ? "overflow-auto" : ""} ${contentCls}`} id="main-dialog-content">
         
         <div className="table w-full">
         {children}
         
         </div>
        </div>
        </>
    )
}

export const PageDialogFooter = ({ children, footerList, customClasses = "" }) => {
    const returnButton = (item, itemKey) => {
        if (item?.type == 'save' || item?.type == 'add' || item?.type == 'create' || item?.type == 'update') {
            return <button
                key={'button_' + item?.type + '_' + itemKey}
                className={`py-1 px-2.5 font-normal border border-bgGreen rounded bg-bgGreen text-[14px] text-white hover:bg-primary-hover ${item?.loading ? 'cursor-not-allowed' : 'cursor-pointer'} ${item?.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                type="button"
                disabled={item?.disabled ? item?.disabled : item?.loading ? item.loading : false}
                onClick={item?.action}
            >
                {item?.loading ?
                item?.type == 'update' && 'Updating...' || item?.type == 'save' && 'Saving...' || item?.type == 'add' && 'Adding...' || item?.type == 'create' && 'Creating...'
                :
                item?.title
                }
            </button>
        } else if (item?.type == 'edit') {
            return <button
                key={'button_' + item?.type + '_' + itemKey}
                className={`py-1 px-2.5 font-normal rounded border border-bgGreen text-[14px] text-bgGreen hover:bg-bgGreen hover:text-white ${item?.loading ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                type="button"
                onClick={item?.action}
            >
                {item?.loading ?
                item?.type == 'edit' && 'Editing...'
                :
                item?.title
                }
            </button>
        }
        else if (item?.type == 'delete' || item?.type == 'remove') {
            return <button
                key={'button_' + item?.type + '_' + itemKey}
                className={`py-1 px-2.5 font-normal rounded text-[14px] text-danger-hover border-danger-hover border  hover:bg-danger-hover hover:text-white ${item?.loading ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                type="button"
                disabled={item?.disabled}
                onClick={item?.action}
            >
                {item?.loading ?
                item?.type == 'delete' && 'Deleting...' || item?.type == 'remove' && 'Removing...'
                :
                item?.title
                }
            </button>
        } else if (item?.type == 'cancel' || item?.type == 'close') {
            return <button
                key={'button_' + item?.type + '_' + itemKey}
                className="py-1 px-2.5 font-normal rounded text-[14px] text-black-300 border-gray-c3 border  hover:bg-gray-e5 hover:text-black-300"
                type="button"
                disabled={item?.disabled}
                onClick={item?.action}
            >
                {item?.title}
            </button>
        }  else if(item?.type == "hyperlink") {
            return <button
                key={'button_' + item?.type + '_' + itemKey}
                className={`font-medium text-blue-600 dark:text-blue-500 hover:underline mr-[30px]'}`}
                type="button"
                style={{marginLeft:"auto",marginRight:"30px"}}
                disabled={item?.disabled ? item?.disabled : item?.loading ? item.loading : false}
                onClick={item?.action}
            >
                {item?.loading ?
                item?.type == 'update' && 'Updating...' || item?.type == 'save' && 'Saving...' || item?.type == 'add' && 'Adding...' || item?.type == 'create' && 'Creating...'
                :
                item?.title
                }
            </button>
        }
        else if(item?.type == "content") {
            return <>
                {item?.content}
            </>
        }
    }

    return (
        <>
        <div className={`flex items-center gap-2 rounded-bl rounded-br justify-start bg-gray-f8 popup-footer-shadow z-10 p-2 ${customClasses}`}>
            {children ? children : ''}
            {footerList && footerList.map((item, itemKey) => returnButton(item, itemKey))}

        </div>
        </>
    )
}

export default MainPageDialog;